import React from 'react';
import { Route } from 'react-router';
import type { ChangeHook } from 'react-router';

import { Route as CourseraRoute } from '@coursera/react-router';

import ClipsApp from 'bundles/clips/components/ClipsApp';
import loadOnRoute from 'bundles/common/components/loadOnRoute';
import NotFound from 'bundles/phoenix/components/NotFound';
import UserExperienceContextProvider from 'bundles/unified-common/providers/UserExperienceContextProvider';

const ClipsRootContainer = () => import('bundles/clips/components/ClipsRootContainer');

const ClipsAppWithUserExperience = (props: React.ComponentProps<typeof ClipsApp>) => (
  <UserExperienceContextProvider>
    <ClipsApp {...props} />
  </UserExperienceContextProvider>
);

const scrollToTopOnNavigate: ChangeHook = (prevState, nextState) => {
  if (nextState.location.action !== 'PUSH') {
    // history navigation
    return;
  }

  if (nextState.location.pathname !== prevState.location.pathname) {
    // always on path navigation
    window.scrollTo(0, 0);
  }
};

export default (
  <CourseraRoute
    onChange={scrollToTopOnNavigate}
    handle={{
      tracking: {
        data: (params) => ({
          page: { segment: 'enterprise' },
          enterprise: {
            organizationSlug: params?.orgSlug,
            ...(params?.programSlug ? { programSlug: params.programSlug } : {}),
          },
        }),
      },
    }}
  >
    <Route path="/" component={ClipsAppWithUserExperience}>
      <Route path="clips/:courseSlug/:itemId" getComponent={loadOnRoute(ClipsRootContainer)} />;
      <Route path="videos/:courseSlug/:itemId" getComponent={loadOnRoute(ClipsRootContainer)} />;
      {/* This catch-all *, status=404 route is important for SSR. */}
      <Route path="*" component={NotFound} />
    </Route>
  </CourseraRoute>
);
